import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useScrollIntoViewWithinContainer } from "@circle-react/hooks/utils/useScrollIntoViewWithinContainer";
import { Badge } from "@circleco/compass/components/Badge";
import { Typography } from "@circleco/compass/components/Typography";
import type { Cue as WebVTTCue } from "webvtt-parser";

import { parseCueTime } from "./helpers";

export interface CueProps {
  container: HTMLElement | null;
  cue: WebVTTCue;
  isCurrentCue?: boolean;
  onSeek: (time: number) => void;
  shouldScroll?: boolean;
}

export const Cue = ({
  cue,
  container,
  isCurrentCue = false,
  shouldScroll = true,
  onSeek,
}: CueProps) => {
  const elementRef = useScrollIntoViewWithinContainer<HTMLButtonElement>(
    container,
    isCurrentCue && shouldScroll,
  );

  return (
    <button
      type="button"
      className={classNames(
        "flex cursor-pointer items-start gap-3 rounded-lg p-2 text-left transition-colors duration-200 hover:bg-secondary",
        { "bg-active": isCurrentCue },
      )}
      onClick={event => {
        event.stopPropagation();
        onSeek(cue.startTime);
      }}
      ref={elementRef}
    >
      <Badge
        className="mt-0.5 shrink-0"
        variant={isCurrentCue ? "primary" : "secondary"}
        label={parseCueTime(cue.startTime?.toString())}
      />
      <Typography variant="body-sm" color="primary">
        {cue.text}
      </Typography>
    </button>
  );
};
